export enum InformationScreenTypeEnum {
  Error = 'ERROR',
  LinkExpired = 'LINK_EXPIRED',
  AccountNotFound = 'ACCOUNT_NOT_FOUND',
  MaxLimitReached = 'MAX_LIMIT_REACHED',
  GenericError = 'GENERIC_ERROR',
}

export const screenLevelErrorMessageCodes = [
  'ChangePasswordTooManyOtpAttempts',
  'ChangePasswordTooManyAttempts',
  'ChangeEmailTooManyOtpAttempts',
  'ChangeEmailTooManyAttempts',
  '4',
  '6',
  '11',
  '429',
];

export const inlineErrorCodes = [
  '5',
  '6',
  '401',
  '400',
  'ChangePasswordExpiredOtp',
  'ChangePasswordIncorrectOtp',
  'ChangeEmailIncorrectOtp',
  'ChangeEmailExpiredOtp',
];
